import React from "react";
import {
  Title,
  Text,
  Chip,
  createStyles,
} from "@mantine/core";
import { Similarity } from "../../utiles/similar";

const brandColor = "rgb(42, 155, 73)";

const useStyles = createStyles((theme, _params, getRef) => ({
  title: {
    textAlign: "center",
    fontWeight: 600,
    fontSize: 18,
    color: theme.colorScheme === "dark" ? theme.white : theme.colors.gray[8],
    marginBottom: theme.spacing.sm,
  },
  group: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: 10,
  },
  label: {
    border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : "#dee2e6"}`,
    backgroundColor: "transparent",
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
    borderRadius: theme.radius.xl,
    transition: "all 0.2s ease",
    "&[data-checked]": {
      "&, &:hover": {
        backgroundColor: "rgba(42,155,73,0.08)",
        color: brandColor,
        borderColor: brandColor,
      },
      [`& .${getRef("iconWrapper")}`]: { color: brandColor },
    },
    "&:hover": { borderColor: brandColor, color: brandColor },
  },
  iconWrapper: {
    ref: getRef("iconWrapper"),
    color: theme.colors.gray[5],
  },
}));

const SimilarityChips = ({ setCookie, cookie }) => {
  const { classes } = useStyles();

  return (
    <>
      <Title className={classes.title} align="center" mt="md" order={4}>
        اختر{" "}
        <Text component="span" color={brandColor} inherit>
          الدقة المناسبة للمطابقة
        </Text>
      </Title>
      <div className={classes.group}>
        <Chip.Group defaultValue={cookie.similarity || "0.95"}>
          {Similarity.map((item) => (
            <Chip
              key={item.title}
              value={item.value}
              size="md"
              radius="xl"
              classNames={classes}
              onClick={() => {
                setCookie("similarity", item.value);
              }}
            >
              {item.title}
            </Chip>
          ))}
        </Chip.Group>
      </div>
    </>
  );
};

export default SimilarityChips;
